module.exports = __webpack_public_path__ + "media/news2.39ee05fa.mp4";